export const environment = {
  production: true,
  BASE_DOMAIN:'https://wms-dev.apollosupplychain.com/',
  New_BASE_DOMAIN:'https://wms-dev.apollosupplychain.com/',
  COOKIE_DOMAIN: 'localhost',
  ORDER_URL: 'https://wms-dev.apollosupplychain.com/',
  WebsocketUrl: 'wss://wms-dev.apollosupplychain.com/websocket-service/ws/notifications'
};
